blue.ready("cta-slider", ".cta-slider", (cta) => {
  const bannerImages = [...cta.querySelectorAll(".cta-slider__image > img")];
  const topImages = [...cta.querySelectorAll(".cta-slider__pager.top > a")];
  const bottomImages = [
    ...cta.querySelectorAll(".cta-slider__pager.bottom > a"),
  ];
  const contentSections = [...cta.querySelectorAll(".cta-slider__content")];
  const count = topImages.length;
  const autoPlay = cta.classList.contains("cta-slider--autoplay");
  let interval = null;

  const select = function (selectedIndex) {
    return function curried_select(e) {
      if (e) {
        e.preventDefault();
      }

      if (interval) {
        clearTimeout(interval);
      }

      bannerImages
        .filter((img, index) => index != selectedIndex)
        .forEach((img) => img.classList.remove("is-active"));
      topImages
        .filter((img, index) => index != selectedIndex)
        .forEach((img) => img.classList.remove("is-active"));
      bottomImages
        .filter((img, index) => index != selectedIndex)
        .forEach((img) => img.classList.remove("is-active"));
      contentSections
        .filter((elm, index) => index != selectedIndex)
        .forEach((elm) => elm.classList.remove("is-active"));

      bannerImages
        .filter((img, index) => index == selectedIndex)
        .forEach((img) => img.classList.add("is-active"));
      topImages
        .filter((img, index) => index == selectedIndex)
        .forEach((img) => img.classList.add("is-active"));
      bottomImages
        .filter((img, index) => index == selectedIndex)
        .forEach((img) => img.classList.add("is-active"));
      contentSections
        .filter((elm, index) => index == selectedIndex)
        .forEach((elm) => elm.classList.add("is-active"));

      let next = selectedIndex + 1;
      if (next == count) {
        next = 0;
      }

      // If autoplay is enabled, set a timeout to select the next image
      if (autoPlay) {
        interval = setTimeout(() => {
          select(next)();
        }, 5000);
      }
    };
  };

  topImages.forEach((img, index) =>
    img.addEventListener("click", select(index))
  );
  bottomImages.forEach((img, index) =>
    img.addEventListener("click", select(index))
  );

  // initialize on a random image
  select(Math.floor(Math.random() * count))();
});
